import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {KeycloakService} from "keycloak-angular";
import {JwtService} from "../services/jwt.service";
import {jwtDecode} from "jwt-decode";
import {KeycloakJwtModel} from "../models/keycloak-jwt.model";
import { AuthService } from '../services/auth.service';


export const keycloakGuard: CanActivateFn = async (route, state) => {
  const keycloakService: KeycloakService = inject(KeycloakService);
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const jwtTokenService: JwtService = inject(JwtService);
/*   const isLoggedIn = keycloakService.isLoggedIn();
  const token = await keycloakService.getToken();

  let decoded: KeycloakJwtModel = jwtDecode(token);
  let isExpired: boolean = (decoded.exp <= Math.floor(Date.now()/1000));
  let timeStamp = Date.now().toLocaleString('it-IT'); */
  if (!authService.isAuthenticated()) {
 
    await router.navigate(['/authentication/login'])

  }
  //await jwtTokenService.set(token);
  return true;
};
